import * as yup from 'yup';
import DOMPurify from 'dompurify';
import { i18n as I18n } from 'utils/i18n';
import { PHONE_NUMBER_REGEX, INTERNAL_REFERENCE_REGEX } from 'constants/regex';

export const phoneNumber = (
  label?: string = I18n.t(
    'registration.user_details.fields.phone_number.label'
  ),
  required?: boolean = true,
  schema?: ReturnType<typeof yup.string> = yup.string().required()
) =>
  schema.label(label).matches(PHONE_NUMBER_REGEX, {
    excludeEmptyString: !required,
    message: I18n.t('validations.invalid', { name: label }),
  });

export const clientServiceIds = yup
  .array()
  .notRequired()
  .when('serviceLevel', {
    is: val => val === 'client',
    then: yup.array().notRequired(),
    otherwise: yup
      .array()
      .min(1, I18n.t('payment_methods.form.validations.client_service_ids')),
  });

export const internalReference = yup
  .string()
  .ensure()
  .trim()
  .matches(INTERNAL_REFERENCE_REGEX, {
    message: I18n.t('basket.internal_ref.modal.validations.internal_ref'),
    excludeEmptyString: true,
  });

export const validateXSS = (value: string): boolean => {
  const cleanValue = DOMPurify.sanitize(value);
  return value === cleanValue;
};

export const xssErrorMessage = I18n.t('validations.xss');
